<script>
    import {
        NotificationModal,
        UploadPdfModal,
    } from "../../../Components/Common/index.svelte";

    import {
        downLoadIcon,
        duplicateIcon,
        editIcon,
        historyIcon,
        infoIcon,
        uploadIcon,
    } from "../../../Utils/utilConstants.svelte";

    import {
        getAccountCalendarEventType,
        goToURL,
        isObjectEmpty,
        showError,
    } from "../../../Utils/utilFunctions.svelte";

    import { user } from "../../../stores";
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import CalendarListFilesModal from "./CalendarListFilesModal.svelte";
    import CalendarDragAndDropBoard from "./CalendarDragAndDropBoard.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import { DirectEncounterStatus } from "../../../Utils/utilEnums.svelte";
    import { _getDisplayDate, closeViewEncounterSidePanel, openViewEncounterSidePanel } from "../../PatientEncounter/helpers/encounterHelper.svelte";
    import CalendarEventMetadata from "./CalendarEventMetadata.svelte";

    export let isModalOpen = false;
    export let selectedEvent = {};
    export let closeModal = () => {};
    export let handleEditNestedEncounter = () => {};
    export let handleEditEventDetails = () => {};
    export let reloadReOpenCurrentEventModal = async () => {};

    // $: if (!isObjectEmpty(selectedEvent) && isModalOpen)
    //     initData(selectedEvent);
    // else selectedEncounterIdForNotes = null;

    let nestedEncounters = [],
        modalTitle = "",
        modalTitleDoctorNameSc = "";

    let hideArchived = true;

    let isUploadAccountSchedulePdfModalOpen = false,
        allEncounterIds = [],
        isFileListModalOpen = false;

    let selectedEncounterIdForNotes;

    let isLoadingEncounters = false,
        encounters = [];

    const openFilesModal = () => (isFileListModalOpen = true);

    $: showDownloadListIcon =
        nestedEncounters &&
        nestedEncounters.length &&
        nestedEncounters.some((ect) => ect.updatedByOCRDate);

    $: headerOptions = [
        {
            optionText: "Info",
            tooltipContent: {
                component: CalendarEventMetadata,
                props: {
                    event: selectedEvent
                }
            },
            iFont: infoIcon,
            iconName: "infoIcon",
            function: () => {
            },
            showAsTooltip: true,
        },
        {
            optionText: "History",
            iFont: historyIcon,
            iconName: "historyIcon",
            function: () => {
                goToURL(`/ActivityLogs/entityId=${selectedEvent.id}&controller=AccountCalendarEvent&fromDate=2020-01-01`, false); //tue to open in a new tab
            },
            showAsTooltip: true,
        },
        {
            optionText: "Download List",
            iFont: downLoadIcon,
            iconName: "downLoadIcon",
            function: openFilesModal,
            isHidden: !showDownloadListIcon,
            showAsTooltip: true,
        },
        {
            optionText: "Upload List PDF",
            iFont: uploadIcon,
            iconName: "uploadIcon",
            function: () => (isUploadAccountSchedulePdfModalOpen = true),
            isHidden: selectedEvent.eventType !== 1,
            showAsTooltip: true,
        },
        {
            optionText: "Duplicate Event",
            iFont: duplicateIcon,
            iconName: "duplicateIcon",
            function: () => dispatch("duplicateEvent"),
            isHidden: selectedEvent.eventType !== 1,
            showAsTooltip: true,
        },
        {
            optionText: "Edit",
            iFont: editIcon,
            iconName: "editIcon",
            function: () => handleEditEvent(),
            isHidden: $user.role == 2 || selectedEvent.eventType == "encounter",
            showAsTooltip: true,
        },
    ];

    let displayItems = [];

    $: showArchivedToggle = encounters.some((e) => e.status == 9);

    onMount(() => {
        !isObjectEmpty(selectedEvent) && initData(selectedEvent);
    });

    onDestroy(() => {
        selectedEncounterIdForNotes = null;
    });

    const initData = async (event) => {
        if (isObjectEmpty(event)) return;
        const { nestedEncounter, eventType, doctorNameSc, startDate, endDate } =
            event;

        nestedEncounters = nestedEncounter.sort(
            (a, b) =>
                new Date(a.scheduledDate).getTime() -
                new Date(b.scheduledDate).getTime(),
        );

        const isEventEncounter = eventType == "encounter";

        const displayEventType = isEventEncounter
            ? "Encounters"
            : getAccountCalendarEventType(eventType);

        let hospitalName = "",
            surgeonName = "";
        if (event.hospitalName) hospitalName = event.hospitalName;

        if (event.surgeonName) surgeonName = event.surgeonName;

        modalTitle = `${displayEventType}${hospitalName ? ` at the ${hospitalName}` : " "}${surgeonName ? ` with ${surgeonName}` : " "} On the ${startDate[0]} Est for ${startDate[1]} - ${endDate[1]}`;
        modalTitleDoctorNameSc = doctorNameSc ?? "";

        allEncounterIds = nestedEncounters.map((ect) => ect.id);

        if (allEncounterIds.length) {
            isLoadingEncounters = true;

            const searchObj = {};
            searchObj["filter[id]"] = allEncounterIds.join(",");

            await apiMethods.getMethod
                .getPatientEncounter(0, 999999, searchObj)
                .then((res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to load encounter details, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else { 
                        encounters = [...res.results];
                        displayItems = hideArchived ? encounters.filter((e) => e.status != 9) : encounters;
                    }
                });

            isLoadingEncounters = false;
        }

    };

    const handleEditEvent = () => {
        selectedEvent = {
            ...selectedEvent,
            accountId: selectedEvent.doctorId,
            id: selectedEvent.eventId,
            fromDate: selectedEvent.startDate[0].split("/").reverse().join("-"),
            fromTime: selectedEvent.startDate[1],
            toDate: selectedEvent.endDate[0].split("/").reverse().join("-"),
            toTime: selectedEvent.endDate[1],
        };

        handleEditEventDetails(selectedEvent);

    };

    const dispatch = createEventDispatcher();

    export let isLoading;

    const reloadReOpenCurrentEvent = async (newEncounterIds = []) => {
        allEncounterIds = [
            ...new Set([...allEncounterIds, ...newEncounterIds]),
        ];

        // when reload with empty array will cause full encounters returned from backend
        if (allEncounterIds?.length)
            await apiMethods.getMethod
                .getPatientEncounter(0, 999999, {
                    ["filter[id]"]: allEncounterIds.join(","),
                })
                .then(async (res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to load encounter details, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else  {
                        encounters = [...res.results];
                        displayItems = hideArchived ? encounters.filter((e) => e.status != 9) : encounters;
                    }
                });
    };

    const refreshNestedEncounters = async () => {
        // fully reload calendar to get new encounters
        await reloadReOpenCurrentEventModal(selectedEvent);

        initData(selectedEvent);
    };

    let showCancelListModal = false,
        isCancellingList;

    const askCancelList = () => {
        if (!nestedEncounters.length) return;
        showCancelListModal = true;
    };

    let isLoadingGoToEncountersView = false;

    const goToEncountersView = async () => {
        if(isLoadingGoToEncountersView) return;
        isLoadingGoToEncountersView = true;

        const [dayStart, monthStart, yearStart] = selectedEvent.startDate[0].split("/");
        var fromDate = `${yearStart}-${monthStart.padStart(2, "0")}-${dayStart.padStart(2, "0")}`;
        
        const [dayEnd, monthEnd, yearEnd] = selectedEvent.endDate[0].split("/");
        var toDate = `${yearEnd}-${monthEnd.padStart(2, "0")}-${dayEnd.padStart(2, "0")}`;

        //get surgeon unique id from surgeon id
        let providerUniqueId = "";
        if(selectedEvent.surgeonId) {
            const getSurgeonUniqueIdResponse = await apiMethods.getMethod.getAccountDoctorById(selectedEvent.surgeonId);
            if(getSurgeonUniqueIdResponse && !getSurgeonUniqueIdResponse.error) {
                isLoadingGoToEncountersView = false;
                providerUniqueId = getSurgeonUniqueIdResponse?.providerUniqueId;
            }
        }   

        goToURL(`/PatientEncounter/page=0&size=25&doctorId=${selectedEvent?.doctorId}&fromDate=${fromDate}&toDate=${toDate}&hospitalId=${selectedEvent.hospitalId}&surgeonIDs=${providerUniqueId}`, false); //true to open in a new tab
    }

    const cancelCancelList = () => {
        showCancelListModal = false;
    };

    const cancelList = async () => {
        isCancellingList = true;

        const promises = [];
        nestedEncounters.forEach((encounter) => {
            if(encounter.status === 9) return; // if already archived, skip
            promises.push(
                apiMethods.putMethod
                    .updateEncounterStatus(
                        encounter.id,
                        DirectEncounterStatus.Cancelled,
                    )
                    .then((res) => {
                        if (!res || res.error)
                            throw (
                                res.error ??
                                "Failed to update encounter status, please refresh the page and try again and contact support if the issue persists."
                            );
                    })
                    .catch((err) => showError(err)),
            );
        });

        await Promise.all(promises);

        isCancellingList = false;
        showCancelListModal = false;
        await reloadReOpenCurrentEvent();
    };

    const showHideArchived = () => {
        hideArchived = !hideArchived;
        initData(selectedEvent);
    }

    const addNewEncounter = () => {
        openViewEncounterSidePanel({
            type: "create",
            createProps: {
                doctorId: selectedEvent.doctorId,
                hospital: selectedEvent.hospitalId ? { id: selectedEvent.hospitalId, name: selectedEvent.hospitalName } : null,
                surgeonId: selectedEvent.surgeonId,
                scheduledDate: selectedEvent.startDate,
            },
            onCloseFunction: () => {
                closeViewEncounterSidePanel();
                refreshNestedEncounters();
            }
        }); 
    }
</script>

<NotificationModal
    {isModalOpen}
    modalMaxWidth="max-w-[80%] relative"
    cancelText="Close"
    showConfirmBtn={false}
    transformTitleCase={false}
    cancelButtonClass="btn-accent"
    closeModalFunction={closeModal}
    {closeModal}
    {headerOptions}
    zIndex="1000"
>
    <div class="flex items-center gap-x-2" slot="title">
        {#if modalTitleDoctorNameSc}
            <div
                class="w-8 h-8 pt-1 text-[#6B48FF] text-sm flex items-center justify-center bg-white rounded rounded-full cursor-default"
            >
                {modalTitleDoctorNameSc}
            </div>
        {/if}
        <p>{modalTitle}</p>
    </div>

    {#if !isLoading && !isLoadingEncounters}
        <div class="flex flex-row justify-end gap-y-2">
            <button
                class="btn btn-sm btn-secondary rounded text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] min-w-[100px]"
                on:click={addNewEncounter}
            >
                Add encounter
            </button>
        </div>
    {/if}

    <div class="flex flex-col overflow-y-auto overflow-x-hidden relative h-[60vh]">
        {#if isLoading || isLoadingEncounters}
            <div class="flex flex-col flex-1 gap-6 justify-center items-center">
                <progress class="progress progress-primary w-56" />
                <p class="leading-6 font-bold">Loading event details</p>
            </div>
        {:else if isObjectEmpty(selectedEvent)}
            <p class="leading-6 font-bold">No selected events</p>
        {:else if !displayItems?.length}
            <p class="leading-6 font-bold">No nested encounters</p>
        {:else}
            <CalendarDragAndDropBoard
                bind:items={displayItems}
                bind:handleEditNestedEncounter
                bind:selectedEncounterIdForNotes
                {reloadReOpenCurrentEvent}
                {refreshNestedEncounters}
                {selectedEvent}
                on:reload={() => dispatch("reload")}
            />
        {/if}
    </div>

    <div
        slot="beforeButtonsSection"
        class="flex flex-1 gap-x-2"
        class:invisible={!nestedEncounters?.length}
    >
        {#if nestedEncounters.filter((e) => e.status !== 9).length > 0 }
            <button
                class="btn btn-ghost text-error btn-sm rounded text-sm flex-none border-none w-auto h-10"
                on:click={askCancelList}
            >
                Cancel List
            </button>
            <button
                class="btn btn-link text-error btn-sm rounded text-sm flex-none border-none w-auto h-10 flex justify-center"
                on:click={goToEncountersView}
            >
                {#if isLoadingGoToEncountersView}
                    Loading...
                {:else}
                    Encounters View
                {/if}
            </button>
        {/if}
        {#if showArchivedToggle}
            <button
                class="btn btn-sm btn-secondary rounded text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] min-w-[100px]"
                on:click={showHideArchived}
            >
                {hideArchived ? "Show" : "Hide"} archived
            </button>
        {/if}
       
    </div>
</NotificationModal>

<UploadPdfModal
    isModalOpen={isUploadAccountSchedulePdfModalOpen}
    closeModal={() => (isUploadAccountSchedulePdfModalOpen = false)}
    accountId={selectedEvent.doctorId}
    onUploaded={refreshNestedEncounters}
    fromCalendar
    listProp={selectedEvent}
/>

<CalendarListFilesModal
    bind:isModalOpen={isFileListModalOpen}
    {allEncounterIds}
/>

{#if showCancelListModal}
    <NotificationModal
        isModalOpen={showCancelListModal}
        title="Cancel List"
        submitText="Cancel All Encounters"
        confirmButtonClass="btn-error"
        cancelButtonClass="btn-accent"
        cancelText="Close"
        zIndex="1001"
        isConfirming={isCancellingList}
        confirmAction={cancelList}
        closeModal={cancelCancelList}
        closeModalFunction={cancelCancelList}
    >
        Cancel all the encounters in this list?
    </NotificationModal>
{/if}
